// CartNotification.jsx
import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from './../style/CartNotification.module.scss';

const CartNotification = ({ show, onHide, product, addTocart, def_count }) => {

  const [quantity, setQuantity] = useState( def_count > 0 ? def_count : 1 )

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value)
    if (!isNaN(value) && value > 0) {
      addTocart( { product: product.id, count: value }, () => {
        setQuantity( value )
      })
    }
  }

  const incrementQuantity = () => {
    const count = quantity + 1
    addTocart( { product: product.id, count: count }, () => {
      setQuantity( count )
    })
  }

  const decrementQuantity = () => {
    const count = quantity - 1 > 0 ? quantity - 1 : 0
    addTocart( { product: product.id, count: count }, () => {
      setQuantity( count )
    })
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName={styles.modalDialog}
      contentClassName={styles.modalContent}
    >
      <Modal.Header className={styles.modalHeader}>
        <div className={styles.headerIcon}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.62012 16L11.12012 17.5L14.37012 14.5" stroke="#1E9FF6" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8.81043 2L5.19043 5.63" stroke="#1E9FF6" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15.1904 2L18.8104 5.63" stroke="#1E9FF6" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2 7.8501C2 6.0001 2.99 5.8501 4.22 5.8501H19.78C21.01 5.8501 22 6.0001 22 7.8501C22 10.0001 21.01 9.8501 19.78 9.8501H4.22C2.99 9.8501 2 10.0001 2 7.8501Z" stroke="#1E9FF6" strokeWidth="1.25"/>
            <path d="M3.5 10L4.91 18.64C5.23 20.58 6 22 8.86 22H14.89C18 22 18.46 20.64 18.82 18.76L20.5 10" stroke="#1E9FF6" strokeWidth="1.25" strokeLinecap="round"/>
          </svg>
        </div>
        <Modal.Title className={styles.modalTitle}>Добавлено в корзину</Modal.Title>
        <Button 
          variant="link" 
          onClick={onHide} 
          className={styles.closeButton}
        >
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.842285 0.842041L7.15807 7.15783" stroke="black" strokeWidth="0.631579" strokeLinecap="round"/>
            <path d="M7.15771 0.842041L0.841925 7.15783" stroke="black" strokeWidth="0.631579" strokeLinecap="round"/>
          </svg>
        </Button>
      </Modal.Header>
      
      <Modal.Body className={styles.modalBody}>
        <div className={styles.contentWrapper}>
          <div className={styles.imageColumn + ` d-none d-md-flex`}>
            <img src={product.image} alt={product.title} className={styles.productImage} />
          </div>
          <div className={styles.textColumn}>
            <div className='d-flex align-items-start'>
              <div className={styles.imageColumn + ` d-md-none`}>
                <img src={product.image} alt={product.title} className={styles.productImage} />
              </div>
              <div className={styles.textContent}>
                <div className={styles.productArticle}>Арт. {product.article}</div>
                <h3 className={styles.productTitle}>{product.title}</h3>
                <div className={styles.productManufacturer}>{product.manufacturer}</div>
                <div className={styles.productPrice}>
                  {product.price} ₽ / шт
                  <div className={styles.quantitySelector}>
                    <button onClick={decrementQuantity} className={styles.quantityButton}>
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12.5" cy="12.5" r="12.5" fill="white"/>
                        <path d="M18 12.75L7.5 12.75" stroke="#1E9FF6" strokeLinecap="round"/>
                      </svg>
                    </button>
                    <input 
                      type="text" 
                      value={quantity} 
                      onChange={handleQuantityChange}
                      className={styles.quantityInput}
                    />
                    <button onClick={incrementQuantity} className={styles.quantityButton}>
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12.5" cy="12.5" r="12.5" fill="white"/>
                        <path d="M12.75 7.5V18" stroke="#1E9FF6" strokeLinecap="round"/>
                        <path d="M18 12.75L7.5 12.75" stroke="#1E9FF6" strokeLinecap="round"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.buttons}>
              <Button variant="outline-primary" className={styles.continueButton} onClick={onHide}>
                Продолжить
              </Button>
              <Button variant="primary" className={styles.cartButton} as="a" href="/korzina/">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.cartIcon}>
                  <path d="M6.24092 1.41699L3.67676 3.98824" stroke="white" strokeWidth="1.0625" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M10.7598 1.41699L13.3239 3.98824" stroke="white" strokeWidth="1.0625" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M1.4165 5.56022C1.4165 4.2498 2.11775 4.14355 2.989 4.14355H14.0107C14.8819 4.14355 15.5832 4.2498 15.5832 5.56022C15.5832 7.08314 14.8819 6.97689 14.0107 6.97689H2.989C2.11775 6.97689 1.4165 7.08314 1.4165 5.56022Z" stroke="white" strokeWidth="1.0625"/>
                  <path d="M6.91357 9.91699V12.4316" stroke="white" strokeWidth="1.0625" strokeLinecap="round"/>
                  <path d="M10.1719 9.91699V12.4316" stroke="white" strokeWidth="1.0625" strokeLinecap="round"/>
                  <path d="M2.479 7.08301L3.47775 13.203C3.70442 14.5772 4.24984 15.583 6.27567 15.583H10.5469C12.7498 15.583 13.0757 14.6197 13.3307 13.288L14.5207 7.08301" stroke="white" strokeWidth="1.0625" strokeLinecap="round"/>
                </svg>
                Перейти в корзину
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

CartNotification.defaultProps = {
  product: {
    article: '03-15-1-10',
    title: 'Evers Life Лосьон-спрей для предотвращения образования очаговых покраснений',
    manufacturer: 'ООО "Эверс Груп Рус"',
    price: '599 ₽ / шт',
    image: '/src/assets/product.png'
  }
};

export default CartNotification;